import { Card, Stack, Typography } from '@mui/joy';
import { useCallback, useState } from 'react';

import { Chat, Input } from 'chatbot/components';
import { useLlmActions } from 'chatbot/hooks';
import { Notification, SlidingPanel } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { Level, Size } from 'theme/enums';

import OPTIONS from './options.json';

interface IProps {
  quoteId: number;
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onComplete?: () => void;
  size?: Size;
}

export const ChatPanel = ({ quoteId, title, isOpen, onClose, onComplete, size }: IProps) => {
  const [threadId, setThreadId] = useState<string | undefined>(undefined);
  const [initialMessage, setInitialMessage] = useState<string | undefined>(undefined);

  const { startChatbot } = useLlmActions();

  const onStartChatbot = async (message: string) => {
    const { threadId } = await startChatbot();

    setThreadId(threadId);
    setInitialMessage(message);
  };

  const onReset = useCallback(() => {
    setThreadId(undefined);
    setInitialMessage(undefined);
  }, []);

  const onClosePanel = useCallback(() => {
    onClose();
    onReset();
  }, [onClose, onReset]);

  return (
    <SlidingPanel title={title} isOpen={isOpen} onClosePanel={onClosePanel} size={size}>
      <Chat
        quoteId={quoteId}
        threadId={threadId}
        initialMessage={initialMessage}
        onReset={onReset}
        onComplete={onComplete}
      />

      <Notification position={NotificationPosition.DRAWER} />

      {!initialMessage && (
        <>
          <Stack>
            {OPTIONS.map((option) => (
              <Card
                key={option}
                sx={{
                  border: 0,
                  cursor: 'pointer',
                  alignSelf: 'flex-start',
                  background: 'linear-gradient(45deg, #E5E0ff, #F1E6F9)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #D5D0FF, #E1D6F9)',
                  },
                }}
                onClick={() => onStartChatbot(option)}
              >
                <Typography level={Level.BODY_MD}>{option}</Typography>
              </Card>
            ))}
          </Stack>
          <Input onSubmit={onStartChatbot} />
        </>
      )}
    </SlidingPanel>
  );
};
